import { event, GtagEvent } from "./event";

export interface Login extends GtagEvent {
    method?:string;
}
export const login = ($_?:Login) => event('login',$_);